import { getScreenName } from '../../../Utils/helper';

import { fireEvent } from '../../../Utils/fireEvent';

export const applyClickEffect = (event, className) => {
  let x = event.currentTarget;
  x.classList.add(className);
  setTimeout(() => {
    x.classList.remove(className);
  }, 200);
};

export const clickedCardInSectionEvent = (
  cardDeeplink,
  cardShape,
  cardName,
  cardId,
  sectionHeading,
) => {
  fireEvent({
    category: 'clicked_card_in_myloshop',
    screen_name: getScreenName(),
    section_name: sectionHeading,
    card_id: cardId,
    deeplink_value: cardDeeplink,
    card_name: cardName,
    shape: cardShape,
  });
};

export const clickedKnowMoreEvent = (buttonCta, sectionHeading) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: getScreenName(),
    parent: 'SMC_infographic_store_home',
    cta: buttonCta,
    section_name: sectionHeading,
  });
};
